/**
 * R6's favorite teams row and R7's empty state. `/profile/get` returns only
 * `favoriteTeamIds: string[]`, so each id resolves through its own
 * `AccountTeamPlate`.
 *
 * No follow or unfollow control anywhere in this file. R6's last sentence
 * forbids it. Find teams and Browse teams open the favorite teams manager
 * at `/account/teams`, where following and removing live (ISSUE-1399).
 */
import { Link } from "@tanstack/react-router";
import type { ReactNode } from "react";

import {
  BROWSE_TEAMS_ACTION,
  FAVORITE_TEAMS_TITLE,
  FIND_TEAMS_ACTION,
  TEAMS_EMPTY_BODY,
  TEAMS_EMPTY_TITLE,
} from "./accountHomeCopy";
import { AccountTeamPlate } from "./AccountTeamPlate";

export type typeAccountFavoriteTeamsRowProps = {
  teamIds: readonly string[];
  testId?: string | undefined;
};

const LINK_CLASS =
  "inline-flex min-h-touch-target items-center text-body-strong text-primary underline-offset-2 hover:underline";

export const AccountFavoriteTeamsRow = (
  props: typeAccountFavoriteTeamsRowProps,
): ReactNode => (
  <section
    className="flex flex-col gap-3 rounded-lg border border-line bg-surface p-4"
    data-testid={props.testId}
  >
    {props.teamIds.length === 0 ? (
      <div
        className="flex flex-col items-center gap-2 py-2 text-center"
        data-testid="account-teams-empty"
      >
        <h2 className="text-h2 text-ink">{TEAMS_EMPTY_TITLE}</h2>
        <p className="text-body text-ink-secondary">{TEAMS_EMPTY_BODY}</p>
        <Link
          to="/account/teams"
          data-testid="account-teams-browse"
          className={LINK_CLASS}
        >
          {BROWSE_TEAMS_ACTION}
        </Link>
      </div>
    ) : (
      <>
        <h2 className="text-h2 text-ink">{FAVORITE_TEAMS_TITLE}</h2>
        <ul className="flex flex-wrap gap-4" data-testid="account-teams">
          {props.teamIds.map((id) => (
            <li key={id}>
              <AccountTeamPlate teamId={id} />
            </li>
          ))}
        </ul>
        <Link
          to="/account/teams"
          data-testid="account-teams-find"
          className={LINK_CLASS}
        >
          {FIND_TEAMS_ACTION}
        </Link>
      </>
    )}
  </section>
);
